import React from 'react';
import { Route } from '../types';
import RouteCard from './RouteCard';

interface MyRoutesProps {
  myRoutes: Route[];
  onRemoveRoute: (route: Route) => void;
  onClearAll: () => void;
  userLocation?: { latitude: number; longitude: number };
  showPitches?: boolean;
}

export default function MyRoutes({
  myRoutes,
  onRemoveRoute,
  onClearAll,
  userLocation,
  showPitches = false,
}: MyRoutesProps) {
  return (
    <div className="max-w-4xl mx-auto space-y-6">
      {/* Header */}
      <div className="card p-4">
        <div className="flex items-center justify-between mb-4">
          <h2 className="text-lg font-semibold text-gray-800">
            My Routes ({myRoutes.length})
          </h2>
          {myRoutes.length > 0 && (
            <button
              onClick={onClearAll}
              className="btn-secondary text-sm"
            >
              Clear All
            </button>
          )}
        </div>
        
        {myRoutes.length === 0 ? (
          <p className="text-gray-500 text-center py-8">
            No routes saved yet. Add routes from the search results by clicking the + button!
          </p>
        ) : (
          <p className="text-sm text-gray-600">
            Your saved routes will appear on the map when you switch to map view.
          </p>
        )}
      </div>

      {/* Route Cards */}
      {myRoutes.length > 0 && (
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
          {myRoutes.map((route) => (
            <div key={route.Route}>
              <RouteCard
                route={route}
                distance={userLocation ? 
                  Math.sqrt(
                    Math.pow(route['Area Latitude'] - userLocation.latitude, 2) +
                    Math.pow(route['Area Longitude'] - userLocation.longitude, 2)
                  ) * 69 // Rough conversion to miles
                  : undefined
                }
                isInBelayList={true}
                onToggleBelayList={() => onRemoveRoute(route)}
                userLocation={userLocation}
                showPitches={showPitches}
              />
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
